module.exports = __webpack_public_path__ + "static/media/inst.28dea628.png";